import React from 'react';
import PropTypes from 'prop-types';
import {TestTubeDropdown} from './TestTubeDropdown';
import {TestTube} from './TestTube';
import {TestTubeLabel} from './TestTubeLabel';
import {TestTubeImage} from './TestTubeImage';
import {TestTubeFeedback} from '@learningblocks/storybook-components';
import {RenderHTML} from '@learningblocks/shared-components';
import './style.scss';

export const MainContent = (props) => {
  const setSampleCorrect = (sample) =>
    sample.currentValue === sample.actualValue;

  const renderSampleOption = (option) => {
    const isCorrect = setSampleCorrect(option);
    return (
      <TestTube key={option.id}>
        <TestTubeLabel label={option.label} />
        <TestTubeImage tubeType={props.tubeType}>
          <TestTubeDropdown
            id={option.id}
            options={option.options}
            onChange={props.onDropdownChange}
            showFeedback={option.showFeedback}
            currentValue={option.currentValue}
            isCorrect={isCorrect}
          />
          <TestTubeFeedback
            isCorrect={isCorrect}
            showFeedback={option.showFeedback}
          />
        </TestTubeImage>
      </TestTube>
    );
  };

  return (
    <div className='labelTestTube_content'>
      <div className='labelTestTube_content__question'>
        <RenderHTML content={props.question} />
      </div>
      <div className='labelTestTube_content__options'>
        {props.samples.map(renderSampleOption)}
      </div>
    </div>
  );
};

MainContent.propTypes = {
  /**
   * String representing question of the card
   */
  question: PropTypes.string.isRequired,
  /**
   * List of samples
   */
  samples: PropTypes.arrayOf(PropTypes.object).isRequired,
  /**
   * Funciton to invoke when an option is selected
   */
  onDropdownChange: PropTypes.func.isRequired,
  /**
   * Type of tube to be rendered in Tube
   */
  tubeType: PropTypes.oneOf(['TUBE', 'GLASS_TUBE']),
};
